module.exports = __webpack_public_path__ + "img/copy-icon.f6a60e0d.svg";